import type { CommonHeroIconProps } from "./common-hero-icon-props.types"

export function OutlineChevronDownIcon({ className }: CommonHeroIconProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      viewBox="0 0 24 24"
    >
      <path d="M19 9l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
